export { startSegmentCollection, setSegmentBytesLimit } from './segmentCollection'
export { DeflateWorker, DeflateWorkerAction, DeflateWorkerListener } from './deflateWorker'
export { startDeflateWorker } from './startDeflateWorker'
export { SEGMENT_BYTES_LIMIT } from './segmentCollection'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-rum/src/domain/segmentCollection/index.ts